import { SafeAreaView, StatusBar } from "react-native";
import React from "react";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const DefaultHeader = () => {
	const user = useAppSelector(s => s.auth.subUser!);
	return (
		<SafeAreaView
			style={{ backgroundColor: getPrimaryColor(user) || "#40b8b8" }}
		>
			<StatusBar backgroundColor={getPrimaryColor(user) || "#40b8b8"} />
		</SafeAreaView>
	);
};

export default DefaultHeader;
